// Django-injected global variables
declare global {
  const HCAPTCHA_SITE_KEY: string
  const PROPERTIES: any[]
  const DOMAINS: any[]
  const API_KEYS: any[]
  const ACCOUNT_DETAILS: any
  const PAYMENT_METHODS: any[]
  const STRIPE_PK: string
  const BILLING_ACTIVE: boolean
  const BILLING_MANUAL: boolean
  const PLANS: any[]
  const CURRENT_SUBSCRIPTION: any
  const COUNTRIES: { code: string; name: string }[]
  const TAX_ID_TYPES: { code: string; name: string }[]
}

import { ref } from 'vue'
import { defineStore } from 'pinia'
import { readCsrf } from '@/utils'

export const useGlobalStore = defineStore('globals', () => {
  const hcaptcha_key = ref<string>(
    typeof HCAPTCHA_SITE_KEY !== 'undefined' ? HCAPTCHA_SITE_KEY : '',
  )
  const csrfToken = ref<string>(readCsrf())
  const loading = ref<boolean>(false)

  return {
    hcaptcha_key,
    csrfToken,
    loading,
  }
})
